/**
 * Creates a new RegExp that matches the same string as the original RegExp, but only at the beginning and end of the string i.e exact match.
 *
 * @param regex - The original RegExp to make exact.
 * @returns A new RegExp that matches the same string as the original RegExp, but only as exact match.
 */
export function makeExactRegexp(regex: RegExp) {
  return new RegExp(`^${regex.source}$`, regex.flags)
}

export function makeGlobalRegexp(regex: RegExp) {
  return new RegExp(regex.source, `${regex.flags}g`)
}
